(() => {
  const mark = () => {
    const path = location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.c2-hero header nav a,.c2-desktop-nav a,.mobile-menu a,.dp-menu nav a').forEach(a => {
      const url = new URL(a.href, location.origin);
      const target = url.pathname.replace(/\/$/, '') || '/';
      if (!url.hash && (target === path || (target.startsWith('/products/') && path.startsWith('/products/')))) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  };
  mark();
  document.addEventListener('shopify:section:load', mark);
})();
